import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import Danish locale files
import daCommon from './locales/da/common.json';
import daNavigation from './locales/da/navigation.json';
import daPages from './locales/da/pages.json';
import daStats from './locales/da/stats.json';
import daForms from './locales/da/forms.json';
import daErrors from './locales/da/errors.json';

// Import English locale files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enPages from './locales/en/pages.json';
import enStats from './locales/en/stats.json';
import enForms from './locales/en/forms.json';
import enErrors from './locales/en/errors.json';

const resources = {
  da: {
    common: daCommon,
    navigation: daNavigation,
    pages: daPages,
    stats: daStats,
    forms: daForms,
    errors: daErrors
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    pages: enPages,
    stats: enStats,
    forms: enForms,
    errors: enErrors
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('i18nextLng') || 'da',
  fallbackLng: 'da',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
